export { GlobalCss, DefaultGlobalCss } from './GlobalCss'
